"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_HEADER_BUTTON_SORT_ICON_COLOR = exports.TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR = exports.TABLE_HEADER_BUTTON_BORDER_WIDTH = exports.TABLE_HEADER_BUTTON_BORDER_COLOR = exports.ACTION_BUTTON_WIDTH = void 0;
var ACTION_BUTTON_WIDTH = 20;
exports.ACTION_BUTTON_WIDTH = ACTION_BUTTON_WIDTH;
var TABLE_HEADER_BUTTON_BORDER_WIDTH = 2;
exports.TABLE_HEADER_BUTTON_BORDER_WIDTH = TABLE_HEADER_BUTTON_BORDER_WIDTH;
var TABLE_HEADER_BUTTON_BORDER_COLOR = 'primary70';
exports.TABLE_HEADER_BUTTON_BORDER_COLOR = TABLE_HEADER_BUTTON_BORDER_COLOR;
var TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR = 'primary80';
exports.TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR = TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR;
var TABLE_HEADER_BUTTON_SORT_ICON_COLOR = 'primary70';
exports.TABLE_HEADER_BUTTON_SORT_ICON_COLOR = TABLE_HEADER_BUTTON_SORT_ICON_COLOR;